<div class="page-root">
    <map-account-header-component *ngIf="!userStateService.principal.provider">
        <ng-container *ngIf="userStateService.isSuperadmin else overlayTabs">
            <settings-header-breadcrumbs [breadCrumbs]="breadCrumbs"
                [componentName]="componentName"></settings-header-breadcrumbs>
        </ng-container>

        <ng-template #overlayTabs>
            <map-overlay-tabs [breadCrumbs]="breadCrumbs" [componentName]="componentName"></map-overlay-tabs>
        </ng-template>
    </map-account-header-component>
    <div class="page">
        <div class="page-container">
            <div class="table-actions-with-filters">
                <div class="toolbar-title" style="margin-bottom: 8px;">
                    Consolidated Risk Score
                </div>
            </div>
            <div class="table-container">
                <div class="table-content">
                    <consolidated-risk-score-list [accountId]="accountId"></consolidated-risk-score-list>
                </div>
            </div>
        </div>
    </div>
</div>
